import creditNoteAPI from '@/services/API/creditNote'
import moment from 'moment';
import { Message } from 'element-ui';

function buildSearchAndFiltersParams(state){
  var params = {};

   params.searchTerms = state.search;

   params.limit = state.per_page;
   params.page = state.page;

   params.orderBy = state.orderBy.orderName;
   params.direction = state.orderBy.direction;

   if(params.page==0)params.page=1;
   return params;
}

const fetchNextCreditNotesPage = function({commit, dispatch, state}){

  commit('SET_PAGE',state.page+1);
  // console.log("fetchNextCustomersPage : ", state.page);
  let params = buildSearchAndFiltersParams(state);
  commit('SET_LOADING', true);
  return creditNoteAPI.fetchCreditNotes(params)
    .then(creditNotes=>{
      if(creditNotes.count){
        commit('UPDATE_CREDIT_NOTES', creditNotes.list);
        commit('SET_COUNT', creditNotes.count );
        commit('SET_PAGES', creditNotes.pages );
      }
      commit('SET_LOADING', false);
    })
}

const fetchCreditNotes = function({commit, state}){

  let params = buildSearchAndFiltersParams(state);
  // console.log("fetchCreditNotes : ", state.page);
  if(state.outDated || _.isEmpty(state.list)){
    commit('SET_LOADING', true);
    return creditNoteAPI.fetchCreditNotes(params)
      .then(creditNotes=>{
        if(creditNotes.count!=null){
          commit('SET_CREDIT_NOTES', creditNotes.list);
          commit('SET_COUNT', creditNotes.count );
          commit('SET_PAGES', creditNotes.pages );
        }else{
          commit('SET_CREDIT_NOTES', creditNotes);
        }
        commit('SET_LOADING', false);
      })
  }
}

const changeMode = function({commit}, mode){
  commit('SET_MODE',mode);
}

const invalidateList = function({commit, dispatch}){
  commit('INVALIDATE_LIST');
  commit('SET_PAGE',1);
  dispatch('fetchCreditNotes');
}

let searchTimeOut = null;


const setSearch = function({commit,dispatch},search){
  commit('SET_SEARCH',search);
  clearTimeout(searchTimeOut)
  searchTimeOut = setTimeout(() => {
    dispatch('invalidateList');
  }, 300)
}

const resetAllFilters = function({dispatch}){
  dispatch('setSearch','');
  dispatch('resetFilters')
}

const resetFilters = function({commit, dispatch}){
  commit('RESET_FILTERS');
  dispatch('invalidateList');
}

const changeOrderBy = function({commit, state, dispatch}, {orderName, direction}){
  commit('SET_ORDERNAME_AND_DIRECTION', {orderName, direction});
  dispatch('invalidateList');
}

const changeSortIcon = function({commit},icon){
  commit('SET_SORT_ICON',icon);
}

const refundCreditNote = function({commit, rootState}, {creditNoteId, refund}){
  return creditNoteAPI.refund(creditNoteId, refund)
}

const voidCreditNote = function({commit, rootState}, creditNoteId){
  return creditNoteAPI.void(creditNoteId)
}

const reOpenCreditNote = function({commit, rootState}, creditNoteId){
  return creditNoteAPI.reOpen(creditNoteId)
}


export default {
  fetchNextCreditNotesPage,
  changeMode,
  invalidateList,
  fetchCreditNotes,
  setSearch,
  resetAllFilters,
  resetFilters,
  changeOrderBy,
  changeSortIcon,
  refundCreditNote,
  voidCreditNote,
  reOpenCreditNote
};
